import {NotificationOpenedResult} from "./domain/model/notification-opened-result";
import {OpenedEvent} from "onesignal-cordova-plugin/dist/models/NotificationOpened";

export class OneSignalPushNotificationMapper {
  static deserialize(param: OpenedEvent): NotificationOpenedResult {
    return {
      action: param.action.actionId,
      data: param.notification.additionalData,
    }
  }
}
